<template>
  <div class="pt-8 flex flex-col lg:flex-row p-4 min-h-screen bg-light-bg dark:bg-dark-bg dark:text-dark-text">
    <AppSidebar />

    <div class="flex flex-col flex-grow p-6 lg:p-12 space-y-4 h-full">
      <!-- Wiadomość sukcesu lub błędu -->
      <div v-if="message" :class="messageType" class="p-4 rounded-lg mb-4 text-center relative bg-white dark:bg-dark-box-bg dark:text-dark-text dark:border dark:border-dark-border">
        {{ message }}
        <div
            class="absolute bottom-0 left-0 h-1 rounded-lg"
            :style="{ width: progress + '%', backgroundColor: getProgressColor(), borderRadius: '8px' }"
        ></div>
      </div>

      <h1 class="text-2xl font-bold mb-6 text-center lg:text-left">Ustawienia</h1>

      <!-- Change Password Section -->
      <div class="bg-white p-6 rounded-lg shadow-md w-full dark:bg-dark-box-bg dark:border dark:border-dark-border">
        <h2 class="text-xl font-semibold mb-4 text-gray-700 dark:text-dark-text">Zmień hasło</h2>
        <form @submit.prevent="changePassword" class="space-y-4">
          <div>
            <label for="oldPassword" class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1">Stare hasło</label>
            <input
                type="password"
                v-model="oldPassword"
                id="oldPassword"
                class="block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:bg-dark-box-bg dark:text-dark-text dark:border-dark-border"
                required
            />
          </div>

          <div>
            <label for="newPassword" class="block text-sm font-medium text-gray-700 dark:text-dark-text mb-1">Nowe hasło</label>
            <input
                type="password"
                v-model="newPassword"
                id="newPassword"
                class="block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 dark:bg-dark-box-bg dark:text-dark-text dark:border-dark-border"
                required
            />
          </div>

          <button
              type="submit"
              class="bg-button-bg text-button-text py-2 px-4 rounded-md shadow-md hover:bg-button-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
          >
            Zmień hasło
          </button>
        </form>
        <p v-if="passwordChangeMessage" class="text-green-600 mt-4">{{ passwordChangeMessage }}</p>
        <p v-if="passwordErrorMessage" class="text-red-600 mt-4">{{ passwordErrorMessage }}</p>
      </div>

      <!-- Modal for first login -->
      <div v-if="showModal" class="fixed inset-0 top-[-1rem] bg-black bg-opacity-50 flex items-center justify-center z-50 w-full h-full p-8">
        <div class="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full dark:bg-dark-box-bg">
          <h3 class="text-xl font-semibold mb-4">Bezpieczeństwo</h3>
          <p class="text-gray-700 dark:text-dark-text mb-4">Zalogowałeś się po raz pierwszy, ze względu na bezpieczeństwo, zmień hasło.</p>
          <button @click="closeModal" class="bg-teal-700 text-white py-2 px-4 rounded-md w-full hover:bg-teal-700 hover:text-white dark:hover:bg-teal-600 dark:hover:text-white">Zrozumiano</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { useAuthStore } from '@/stores/authStore';
  import settingsService from '@/services/settingsService';
  import AppSidebar from '../AppSidebar.vue';
  import userService from '@/services/userService';

  export default {
    name: 'SettingsDispatcherPage',
    components: {
      AppSidebar
    },
    setup() {
      const authStore = useAuthStore();
      authStore.checkExpiration();
      return { user: authStore.user, authStore };
    },
    data() {
      return {
        oldPassword: '',
        newPassword: '',
        passwordChangeMessage: '',
        passwordErrorMessage: '',
        showModal: false, // Nowa zmienna do kontrolowania widoczności modalu
        message: '',
        messageType: '',
        progress: 0,
      };
    },
    mounted() {
      // Sprawdzamy, czy w URL jest parametr hasLoggedInBefore = false
      const query = this.$route.query;
      if (query.hasLoggedInBefore === 'false') {
        this.showModal = true;

        this.updateHasLoggedInBefore();
      }
    },
    methods: {
      async updateHasLoggedInBefore() {
        try {
          // Wywołujemy funkcję serwisową, przekazując użytkownika
          await userService.updateHasLoggedInBefore(this.user);
          console.log('HasLoggedInBefore został zaktualizowany na true');
        } catch (error) {
          console.error('Błąd podczas aktualizacji hasLoggedInBefore:', error);
        }
      },
      async changePassword() {
        this.passwordChangeMessage = '';
        this.passwordErrorMessage = '';
        try {
          const response = await settingsService.changePassword({
            uid: this.user.uid,
            oldPassword: this.oldPassword,
            newPassword: this.newPassword,
          });
          this.passwordChangeMessage = response.message;
          this.oldPassword = '';
          this.newPassword = '';
          await this.authStore.logout(true);
        } catch (error) {
          this.passwordErrorMessage = 'Błąd: Zmiana hasła się nie powiodła. Spróbuj ponownie.';
          console.error('Error changing password:', error);
        }
      },
      closeModal() {
        this.showModal = false; // Zamykamy modal
      },
      getProgressColor() {
        return this.messageType === 'success-message' ? '#16a34a' : '#b91c1c';
      }
    },
  };
</script>
